<div class="container">
    <div class="c-card c-card-small">
        <div class="c-card-small--body">
            <div class="d-flex justify-content-center">
                <p translate="authentication.after.authenticationInProgress"></p>
            </div>
        </div>
    </div>
</div>
